import {Component} from '@angular/core';
import {ReactiveFormsModule} from '@angular/forms';
import {TranslocoDirective} from '@jsverse/transloco';
import {RouterLink} from '@angular/router';
import {RouteGenerator} from '@core/route-generator';
import {UI_ROUTES} from '@core/ui.routes';

@Component({
  selector: 'app-public-partners',
  imports: [
    ReactiveFormsModule,
    TranslocoDirective,
    RouterLink
  ],
  templateUrl: './partners.component.html',
  styleUrl: './partners.component.scss'
})
export class PartnersComponent {

  public readonly routes = {
    contact: RouteGenerator.abs(UI_ROUTES.public.contact)
  };
}
